module.exports = __webpack_public_path__ + "img/analytics.242fde7a.svg";